export { default } from './SavedCoursesOnboardingTour';
export { default as SavedCoursesOnboardingTour } from './SavedCoursesOnboardingTour';
